import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

import { useGetRecipesQuery } from '@/api';
import Page from '@/modules/component/Page';
import PageMeta from '@/modules/component/PageMeta';
import { registerLocaleResources, useCommonTranslation, useTranslation } from '@/modules/i18n/useTranslation';

import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import RecipeItem from './Recipe';

registerLocaleResources('CookBookPage', { en, es, ru });

declare module '@/modules/i18n/namespaces' {
    interface LocaleNamespaces {
        CookBookPage: typeof en;
    }
}

const CookBookPage = () => {
    const { t } = useTranslation('CookBookPage');
    const { t: tCommon } = useCommonTranslation();
    const { data: recipes, isError } = useGetRecipesQuery();
    return (
        <Page>
            <PageMeta title={t('title')}/>
            <Typography component="div" align="left">
                <h1>{t('heading')}</h1>
                {/* The div keeps the first recipe from being :first-of-type, which Accordion styles since MUI v5
                    (v4 used :first-child): the first recipe keeps its divider and top margin as before */}
                <div>
                    {t('intro')}
                    <br/>
                    {t('joke')}
                    <br/>
                    <br/>
                </div>
                {isError && <Alert severity="error">{tCommon('error.unknown')}</Alert>}
                {recipes?.map((recipe) => <RecipeItem key={recipe.id} recipe={recipe}/>)}
            </Typography>
        </Page>
    );
};

export default CookBookPage;
